export default "__VITE_ASSET__3a793eb8__"